
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/csat-plus",
      function () {
        return require("private-next-pages/csat-plus/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/csat-plus"])
      });
    }
  